import { apiGetRequest, apiGetBlob } from '../../../../utils/api/get';
import { VendorPaymentResponse, VendorPaymentFilters } from '../../model/reports';
import { BASE_URL } from '../../../../utils/auth';

export const fetchVendorPaymentsAPI = (
  token: string,
  filters: VendorPaymentFilters
): Promise<VendorPaymentResponse> =>
  apiGetRequest<VendorPaymentResponse>({
    apiUrl: `${BASE_URL}/reports/vendor-payments`,
    token,
    params: {
      startDate: filters.startDate,
      endDate: filters.endDate,
      vendorId: filters.vendorId,
    },
  });

export const downloadVendorPaymentsAPI = (
  token: string,
  filters: VendorPaymentFilters
): Promise<{ blob: Blob; filename: string }> =>
  apiGetBlob({
    apiUrl: `${BASE_URL}/reports/vendor-payments/download`,
    token,
    params: {
      startDate: filters.startDate,
      endDate: filters.endDate,
      vendorId: filters.vendorId,
      format: filters.format || 'csv',
    },
  });
